/**
 * PartnershipProposal — BLOCK 03 · 제안(동선 분리)
 * 모든 문구/링크는 copy.js(PROPOSAL)에서 가져옴. 하드코딩 0.
 * id="proposal" — BLOCK 01 히어로 CTA(#proposal)의 스크롤 목적지.
 */
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/PartnershipProposal.module.css';
import { PROPOSAL } from './copy';
// 실제 카드 이미지 로딩(Vite import). copy.js cards[].slot은 기록용 문자열.
import cardCorporate from '../../assets/images/card-corporate.jpg';
import cardHotel from '../../assets/images/card-hotel.jpg';

// card.key 기준 매핑(순서 의존 X): company=기업(러닝크루), venue=호텔(테니스선셋)
const CARD_IMAGES = {
  company: cardCorporate,
  venue: cardHotel,
};

export default function PartnershipProposal() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  return (
    <section
      id="proposal"
      ref={ref}
      className={`section ${styles.proposal} ${isVisible ? styles.visible : ''}`}>
      <div className={styles.inner}>
        <h2 className={styles.head}>{PROPOSAL.head}</h2>

        <div className={styles.grid}>
          {PROPOSAL.cards.map((card) => (
            <div key={card.key} className={styles.card}>
              {/* 이미지 슬롯 — 실제 사진을 인라인 backgroundImage로 주입(그라데이션은 fallback 유지) */}
              <div
                className={styles.imageSlot}
                aria-hidden="true"
                data-slot={card.slot}
                style={{ backgroundImage: `url(${CARD_IMAGES[card.key]})` }}
              />
              <span className={styles.eyebrow}>{card.eyebrow}</span>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardBody}>{card.body}</p>
            </div>
          ))}
        </div>

        <div className={styles.cta}>
          <a href={PROPOSAL.ctaHref} className="btn btn-primary">
            {PROPOSAL.ctaLabel}
          </a>
        </div>
      </div>
    </section>
  );
}
